import {
    BIPARCEIRO_VENDEDOR,
    BIPARCEIRO_VENDEDORLOADING,
    BIPARCEIRO_LIST,
    BIPARCEIRO_LISTLOADING,
    BIPARCEIRO_STATUS_CLEAR,
    BIPARCEIRO_STATUS_LOADING,
    BIPARCEIRO_STATUS_SUCCESS,
    BIPARCEIRO_STATUS_ERROR
} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    vendedorlist: [],
    vendedorloading: false,
    list: [],
    listloading: false,
    statusData: null,
    statusLoading: false,
    statusError: null,
    statusRequestId: null,
}

export default (state = INITIAL_STATE, action) => {


    switch (action.type) {

        case BIPARCEIRO_VENDEDOR:
            return { ...state, vendedorlist: action.payload };
        case BIPARCEIRO_VENDEDORLOADING:
            return { ...state, vendedorloading: action.payload };
        case BIPARCEIRO_LIST:
            return { ...state, list: action.payload };
        case BIPARCEIRO_LISTLOADING:
            return { ...state, listloading: action.payload };
        case BIPARCEIRO_STATUS_CLEAR:
            return {
                ...state,
                statusData: null,
                statusLoading: false,
                statusError: null,
                statusRequestId: action.meta && action.meta.requestId
            };
        case BIPARCEIRO_STATUS_LOADING:
            return {
                ...state,
                statusData: null,
                statusLoading: true,
                statusError: null,
                statusRequestId: action.meta && action.meta.requestId
            };
        case BIPARCEIRO_STATUS_SUCCESS:
            if (action.meta && action.meta.requestId !== state.statusRequestId) {
                return state;
            }
            return { ...state, statusData: action.payload, statusLoading: false, statusError: null };
        case BIPARCEIRO_STATUS_ERROR:
            if (action.meta && action.meta.requestId !== state.statusRequestId) {
                return state;
            }
            return { ...state, statusData: null, statusLoading: false, statusError: action.payload };


        default:
            return state;
    }
}
